module.exports = __webpack_public_path__ + "static/media/image-1.c2192ae9.png";